import { isMainnet } from "../config/base"

export const getPreregCookieName = (account: string) => {
  return `prereg_wallet_${isMainnet ? "mainnet" : "rinkeby"}_${account.toLowerCase()}`
}
